import { FC } from "react";
import StepInfo from "pages/StepPages/components";
import Button from "components/shared/Button";
import styles from "./Header.module.sass";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { downloadDoc } from "toolkit/steps/stepFive/viewDocuments/viewDocuments.thunks";
import { useLocation, useParams } from "react-router-dom";

interface HeaderProps {
	docName: string;
}

const Header: FC<HeaderProps> = ({ docName }) => {
	const dispatch = useAppDispatch();

	const state: any = useLocation().state;

	const { documentId } = useParams();

	const selectedDocId = useAppSelector((state) => state.viewDocuments.selectedDocId);

	return (
		<div className={styles.header}>
			<StepInfo info="Просмотр документов по объекту" stepTitle="5. Выбор категории значимости" />
			<Button
				onClick={() => {
					console.log("selectedDocId", selectedDocId);
					console.log("documentId", Number(documentId));

					dispatch(
						downloadDoc({
							docId: Number(documentId),
							// docId: selectedDocId || Number(documentId),
							fileName: state?.name || docName,
						}),
					);
				}}>
				Скачать
			</Button>
		</div>
	);
};

export default Header;
